import { createReducer, on } from '@ngrx/store';
import * as PosSessionsActions from './pos-sessions.actions';
import { initialPosSessionsState } from './pos-sessions.state';

export const posSessionsReducer = createReducer(
  initialPosSessionsState,

  on(PosSessionsActions.loadPosSessions, (state, { params }) => ({
    ...state,
    params: { ...state.params, ...params },
    loading: true,
    error: null,
  })),

  on(PosSessionsActions.loadPosSessionsSuccess, (state, { response }) => ({
    ...state,
    sessions: response.items,
    total: response.total,
    page: response.page,
    limit: response.limit,
    totalPages: response.totalPages,
    loading: false,
    error: null,
  })),

  on(PosSessionsActions.loadPosSessionsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(PosSessionsActions.loadCurrentSession, (state) => ({
    ...state,
    currentSessionLoading: true,
    error: null,
  })),

  on(PosSessionsActions.loadCurrentSessionSuccess, (state, { session }) => ({
    ...state,
    currentSession: session,
    currentSessionLoading: false,
    error: null,
  })),

  on(PosSessionsActions.loadCurrentSessionFailure, (state, { error }) => ({
    ...state,
    currentSessionLoading: false,
    error,
  })),

  on(PosSessionsActions.openSession, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(PosSessionsActions.openSessionSuccess, (state, { session }) => ({
    ...state,
    currentSession: session,
    sessions: [ session, ...state.sessions ],
    loading: false,
    error: null,
  })),

  on(PosSessionsActions.openSessionFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(PosSessionsActions.closeSession, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(PosSessionsActions.closeSessionSuccess, (state, { response }) => ({
    ...state,
    currentSession: state.currentSession?.id === response.session.id ? null : state.currentSession,
    sessions: state.sessions.map(s => s.id === response.session.id ? response.session : s),
    loading: false,
    error: null,
  })),

  on(PosSessionsActions.closeSessionFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(PosSessionsActions.loadOverallStatsSuccess, (state, { stats }) => ({
    ...state,
    overallStats: stats,
  })),

  on(PosSessionsActions.loadSessionStats, (state) => ({
    ...state,
    statsLoading: true,
    selectedSessionStats: null,
  })),

  on(PosSessionsActions.loadSessionStatsSuccess, (state, { stats }) => ({
    ...state,
    selectedSessionStats: stats,
    statsLoading: false,
  })),

  on(PosSessionsActions.loadSessionStatsFailure, (state) => ({
    ...state,
    statsLoading: false,
  })),

  on(PosSessionsActions.loadHelpers, (state) => ({
    ...state,
    helpersLoading: true,
  })),

  on(PosSessionsActions.loadHelpersSuccess, (state, { helpers }) => ({
    ...state,
    helpers,
    helpersLoading: false,
  })),

  on(PosSessionsActions.loadHelpersFailure, (state, { error }) => ({
    ...state,
    helpersLoading: false,
    error,
  })),

  on(PosSessionsActions.addHelper, (state) => ({
    ...state,
    helpersLoading: true,
  })),

  on(PosSessionsActions.addHelperSuccess, (state, { session }) => ({
    ...state,
    currentSession: state.currentSession?.id === session.id ? session : state.currentSession,
    sessions: state.sessions.map(s => s.id === session.id ? session : s),
    helpersLoading: false,
  })),

  on(PosSessionsActions.addHelperFailure, (state, { error }) => ({
    ...state,
    helpersLoading: false,
    error,
  })),

  on(PosSessionsActions.removeHelper, (state) => ({
    ...state,
    helpersLoading: true,
  })),

  on(PosSessionsActions.removeHelperSuccess, (state, { session }) => ({
    ...state,
    currentSession: state.currentSession?.id === session.id ? session : state.currentSession,
    sessions: state.sessions.map(s => s.id === session.id ? session : s),
    helpersLoading: false,
  })),

  on(PosSessionsActions.removeHelperFailure, (state, { error }) => ({
    ...state,
    helpersLoading: false,
    error,
  })),
);

